import * as React from 'react';
import {useEffect, useState} from 'react';
import SamsungPayMobileBox from '../../components/common/SamsungPayMobileBox';
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router-dom';
import {getLanguageName} from '../../utils/getLanguage';
import i18n from '../../i18n/i18n';
import {getPaymentClient, updateTransactionStatus} from '../../libs/GsmpiApi';
import {useDispatch, useSelector} from 'react-redux';
import {setData} from '../../data/paymentClientSlice';
import {
  MOBILE_ERROR_TYPE,
  PAYMENT_STATUS,
  POST_MESSAGE_CONTENT_MESSAGE,
  POST_MESSAGE_TYPE,
  TRANSACTION_STATUS
} from '../../common/constants';
import {postMessageToOpener} from '../../utils/postMessage';
import styles from '../../css/SamsungPayMobileBox.module.css';
import classNames from 'classnames/bind';
import debug from 'debug';
import {fetchDummyPaymentCredentials, fetchPayableCards} from "../../libs/GsmpiApiForStageTest";

const cx = classNames.bind(styles);
const log = debug('app:MobileBridgeForStageWithoutApkPage');

export default function MobileBridgeForStageWithoutApkPage() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const clientId = queryParams.get('clientId');
  const {serviceId, transactionId, sourceOrigin, merchantName} = useSelector((state) => state.paymentClient);
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (clientId) {
      getPaymentClient({clientId: clientId})
        .then((response) => {
          if (response.status === 200) {
            dispatch(setData({
              serviceId: response.data.serviceId,
              transactionId: response.data.transactionId,
              merchantName: response.data.merchantName,
              domains: response.data.domains,
              sourceOrigin: response.data.sourceOrigin
            }));
            return response.data.transactionId;
          }
        })
        .catch(() => {
          navigate(`/gsmpi-web/mobile/${i18n.language}/error`);
        });
    } else {
      navigate(`/gsmpi-web/mobile/${i18n.language}/error`);
    }
  }, [clientId]);

  const getDummyPaymentCredentials = async () => {
    try {
      const payableCardsResult = await fetchPayableCards({transactionId: transactionId});
      const cardId = payableCardsResult.data.cards[0].id;
      return await fetchDummyPaymentCredentials({
        transactionId: transactionId,
        cardId: cardId,
        serviceId: serviceId
      });
    } catch (error) {
      log(`Error in fetching dummy payment credentials: ${error.message}`);
      throw error;
    }
  };

  const handlePayRequestClick = () => {
    setIsDisabled(true);

    getDummyPaymentCredentials().then((dummyPaymentCredentialsResult) => {
      postMessageToOpener({
        type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
        content: {
          status: PAYMENT_STATUS.SUCCESS,
          data: dummyPaymentCredentialsResult.data,
        },
        sourceOrigin: sourceOrigin
      });

      self.close();
    }).catch(() => {navigate(`/gsmpi-web/mobile/${i18n.language}/error`);});
  };

  const handleCloseButtonClick = () => {
    const timeOutPayload = {
      payment: {
        status: TRANSACTION_STATUS.CANCELED,
        reason: 'cancelledByUser'
      },
      timestamp: new Date().getTime()
    };

    updateTransactionStatus(transactionId, timeOutPayload)
      .then(() => {
        navigate(`/gsmpi-web/mobile/${i18n.language}/error`, {state: {errorType: MOBILE_ERROR_TYPE.USER_CANCEL}});
      })
      .catch(() => {
        log('failed to update transaction status');

        navigate(`/gsmpi-web/mobile/${i18n.language}/error`, {state: {errorType: MOBILE_ERROR_TYPE.USER_CANCEL}});
      });
  };

  useEffect(() => {
    const handleDiscontinuedTransaction = (e) => {
      //this will trigger once the page is about to be unloaded and the user hasn't clicked the 'Pay' button
      if (!e.persisted && !isDisabled) {
        postMessageToOpener({
          type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
          content: {
            status: PAYMENT_STATUS.FAIL,
            message: POST_MESSAGE_CONTENT_MESSAGE.USER_CANCEL
          },
          sourceOrigin: sourceOrigin
        });
      }
    };

    window.addEventListener('pagehide', handleDiscontinuedTransaction);

    return () => {
      window.removeEventListener('pagehide', handleDiscontinuedTransaction);
    };
  }, [sourceOrigin, isDisabled]);

  return (
    <SamsungPayMobileBox mobilePageType="main" closeButtonFunction={handleCloseButtonClick}>
      <div id="payment">
        <p className={cx('txt')}>
          <span id="merchantName">{t('pay.gmspi.mobile.main.paymentRequest').replace('%s', merchantName)}</span>
        </p>
        <div className={cx('btn-block')}>
          <button type="button" className={cx('btn')} onClick={(e) => {
            if (isDisabled) {
              e.preventDefault();
            } else {
              handlePayRequestClick();
            }
          }}>
            {t('pay.gsmpi.mobile.main.button1')}
          </button>
        </div>
        <div className={cx('change-region')}>
          <button type="button" onClick={(e) => {e.preventDefault();}}>
            <span className={cx('mpi-regionbtn-text')}>{getLanguageName(i18n.language)}</span>
          </button>
        </div>
      </div>
    </SamsungPayMobileBox>
  );
}